import {Component, Input, OnChanges, OnDestroy, OnInit,
} from '@angular/core';
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport,
  BokkzAlgDataService,
  BokkzIbDataService,
  Box1Berekening,
  IncomeTaxEntity,
  OpbouwEW,
  OpbouwInkomenBox1,
  SpecificatieEW
} from "@snelstart-ventures/fiscaal/domain-logic";
import {filter, Subscription} from 'rxjs';
import {
    AbstractControl,
    FormBuilder,
    FormControl,
    FormGroup,
} from '@angular/forms';
import {Event, NavigationEnd, Router} from '@angular/router';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';


@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning',
  templateUrl: './box1-belastbare-inkomsten-uit-eigenwoning.component.html',
  styleUrls: ['./box1-belastbare-inkomsten-uit-eigenwoning.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box1BelastbareInkomstenUitEigenwoningComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() aangifteRapport = {} as AangifteRapport;
    @Input() berekening = {} as AangifteBerekening;

    specEigenWoningFormGroup = this.fb.group<AangifteRapport>({});
    specEigenWoning = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});
    berekeningBox1 = {} as AangifteBerekening;
    geenOfGeringeEWSFg = {} as FormGroup;

    constructor(
        public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
        private router: Router,
        private fb: FormBuilder,
    ) {
        this.specEigenWoningFormGroup = this.fb.group<AangifteRapport>({
            specificatieEW: this.fb.group<SpecificatieEW>({
                opbouw: this.fb.group<OpbouwEW>({
                    eigenWoningForfait: null as unknown as number,
                    belastDeelKapitaalverzekering: null as unknown as number,
                    eigenWoningRente: null as unknown as number,
                    erfpachtcanon: null as unknown as number,
                    personeelsvoordeel: null as unknown as number,
                    kostenEigenWoningSchuld: null as unknown as number,
                    renteRestschuldEigenWoning: null as unknown as number,
                    kostenRestschuldEigenWoning: null as unknown as number,
                    huurinkomstenEW: null as unknown as number,
                    aandeelInVoordeelEigenWoning: null as unknown as number,
                    aandeelInRenteEnKostenEigenWoning: null as unknown as number,
                    aandeelInSaldoEigenWoning: null as unknown as number,
                } as OpbouwEW),
            } as SpecificatieEW),
        } as AangifteRapport);
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({
            box1: this.fb.group<Box1Berekening>({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>({
                    saldoEigenWoning: null as unknown as number,
                    inkomstenUitEigenWoning: null as unknown as number,
                    aftrekWegensGeenOfGeringeEigenWoningSchuld: null as unknown as number,
                } as OpbouwInkomenBox1),
            } as Box1Berekening),
        } as AangifteBerekening);
        this.geenOfGeringeEWSFg = this.fb.group({
            totaalGOGEWS: null as unknown as number,
        });
    }

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specEigenWoning = value;
                    this.specEigenWoningFormGroup.patchValue(this.specEigenWoning)
                });
                this.dataService.aangifteBerekening.subscribe((value) => {
                    this.berekening = value;
                    this.berekeningBox1FormGroup.patchValue(this.berekening);
                    this.berekenTotaalGOGEWS();
                });
                this.disableFormGroup(this.specEigenWoningFormGroup);
                this.disableFormGroup(this.berekeningBox1FormGroup);
                this.disableFormGroup(this.geenOfGeringeEWSFg);
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
        this.routerSubscription = this.router.events
            .pipe(
                filter(
                    (event: Event): event is NavigationEnd =>
                        event instanceof NavigationEnd,
                ),
            )
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId,false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
      return this.specEigenWoningFormGroup.dirty
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    berekenTotaalGOGEWS() {

            if (this.berekening && this.berekening.box1 && this.berekening.box1.opbouwInkomen &&
                this.berekening.box1.opbouwInkomen.aftrekWegensGeenOfGeringeEigenWoningSchuld) {
                if (!this.aangifte.partnerAangifte) {
                    const bedragGOGEWS = this.berekening.box1.opbouwInkomen.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
                    this.geenOfGeringeEWSFg.patchValue({totaalGOGEWS: bedragGOGEWS});
                } else {
                    const bedragGOGEWSAangever = this.berekening.box1.opbouwInkomen.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
                    const bedragGOGEWSPartner = this.berekening.partnerBerekening?.box1?.opbouwInkomen?.aftrekWegensGeenOfGeringeEigenWoningSchuld || 0;
                    this.geenOfGeringeEWSFg.patchValue({totaalGOGEWS: bedragGOGEWSAangever + bedragGOGEWSPartner});
            }
        }
    }

    protected readonly Object = Object;
}
